import { getConversationMessages } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { useCallback, useRef } from 'react';
export const useLoadMoreMessages = props => {
  const {
    httpClient
  } = props;
  const isLoadingRef = useRef(false);
  return useCallback(async _ref => {
    var _pagingMetadata$curso;
    let {
      limit,
      pagingMetadata,
      conversationId
    } = _ref;
    const cursor = pagingMetadata == null || (_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next;
    if (isLoadingRef.current || !cursor || !conversationId) {
      return;
    }
    try {
      isLoadingRef.current = true;
      const result = await httpClient.request(getConversationMessages({
        conversationId,
        cursorPaging: {
          cursor,
          limit
        }
      }));
      return result.data;
    } catch (error) {
      console.error('Error loading more data:', error);
      throw error;
    } finally {
      isLoadingRef.current = false;
    }
  }, [httpClient]);
};
//# sourceMappingURL=useLoadMoreMessages.js.map